import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2 } from 'lucide-react';
export function PremiumLoader() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-694">
      {loading && <motion.div initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeInOut'
    }} className="fixed inset-0 z-[200] bg-cream flex flex-col items-center justify-center" data-id="element-695">
          <motion.div animate={{
        rotate: 360
      }} transition={{
        duration: 1,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-696">
            <Loader2 className="w-12 h-12 text-combo-green" data-id="element-697" />
          </motion.div>
          <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mt-6 text-xl font-bold text-ink tracking-tight" data-id="element-698">
            Recetas PowerFit
          </motion.h2>
        </motion.div>}
    </AnimatePresence>;
}